import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import type { MutationFunction } from "@tanstack/react-query";

export interface ChangePasswordRequestModel {
	readonly currentPassword: string;
	readonly newPassword: string;
}

export const useChangePassword = () => {
	const http = useHTTP("Required");

	const mutationFn: MutationFunction<HTTPResponse, ChangePasswordRequestModel> = requestModel => {
		return http<undefined, ChangePasswordRequestModel>({
			method: "POST",
			url: "/auth/change-password",
			body: requestModel
		});
	};

	return useHTTPMutation({ mutationFn });
};
